<template>
  <div class="source-content-tabs">
    <div class="source-types">
      <button
        class="tab-btn tab-btn--outlined"
        :class="{
          active: selectedTab === 'templates',
        }"
        data-entity="producer-assets-showTemplates"
        data-test="producer-assets-templatesTab"
        @click="selectedTab = 'templates'"
      >
        Templates
      </button>

      <button
        class="tab-btn tab-btn--outlined"
        :class="{
          active: selectedTab === 'saved-graphics',
        }"
        data-entity="producer-assets-showSavedGraphics"
        data-test="producer-assets-savedGraphicsTab"
        @click="selectedTab = 'saved-graphics'"
      >
        <span class="fas fa-bookmark mr-2" />
        Saved Graphics
      </button>
    </div>

    <component :is="currentTabComponent" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { defineAsyncComponent } from 'vue';

export default {
  name: 'Graphics',
  data() {
    return {
      selectedTab: 'templates',
    };
  },
  computed: {
    currentTabComponent() {
      switch (this.selectedTab) {
        case 'saved-graphics':
          return defineAsyncComponent(() => import('./SavedGraphics.vue'));
        default:
          return defineAsyncComponent(() => import('./GraphicTemplates.vue'));
      }
    },
  },
  created() {
    this.getGraphicsTags();
  },
  methods: {
    ...mapActions(['getGraphicsTags']),
  },
};
</script>
